// ABC SEO/GEO — Block 8: Competitors (SEO + GEO dual comparison).
(function () {
  const { Icon } = window.SGIcons;
  const { Card, CardHead, PageHead } = window.SGKit;

  const DOT = ['var(--sg-blue-500)', '#0A6ED1', '#16A34A', '#F59E0B', '#7C3AED', '#DC2626', '#0891B2', '#DB2777'];

  // Manage who you compare against: add your competitors' websites, remove them,
  // or one-click add the ones DataForSEO auto-discovered.
  function CompetitorManager({ you, saved, suggestions, discovering, busy, msg, onAdd, onRemove, onDiscover }) {
    const [input, setInput] = React.useState('');
    const add = () => { const v = input.trim(); if (v) { onAdd(v); setInput(''); } };
    const savedSet = saved;
    const discoverable = (suggestions || []).filter((s) => savedSet.indexOf(s.domain) < 0).slice(0, 6);
    return (
      <Card>
        <CardHead title="Your competitors" sub={`Competitors for ${you || 'this domain'} — each of your domains keeps its own set. We’ll pull their real metrics for a head-to-head.`} />
        <div style={{ padding: 18 }}>
          {/* you + saved chips */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 14 }}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8, height: 38, padding: '0 14px', borderRadius: 'var(--sg-radius-pill)', border: '1px solid var(--sg-blue-500)', background: 'var(--sg-blue-50)', fontSize: 13, fontWeight: 700, color: 'var(--sg-blue-700)' }}>
              <span style={{ width: 9, height: 9, borderRadius: 3, background: 'var(--sg-blue-500)' }} />{you || 'your site'} <span style={{ fontSize: 9.5, fontWeight: 700, background: 'var(--sg-card)', padding: '1px 6px', borderRadius: 'var(--sg-radius-pill)' }}>YOU</span>
            </span>
            {saved.map((d, i) => (
              <span key={d} style={{ display: 'inline-flex', alignItems: 'center', gap: 7, height: 38, padding: '0 6px 0 14px', borderRadius: 'var(--sg-radius-pill)', border: '1px solid var(--sg-border)', background: 'var(--sg-card)', fontSize: 13, fontWeight: 600, color: 'var(--sg-text)' }}>
                <span style={{ width: 9, height: 9, borderRadius: 3, background: DOT[(i + 1) % DOT.length] }} />{d}
                <button onClick={() => onRemove(d)} disabled={busy} aria-label="Remove" style={{ width: 24, height: 24, borderRadius: '50%', border: 'none', background: 'transparent', cursor: 'pointer', color: 'var(--sg-text-3)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="x" size={14} /></button>
              </span>
            ))}
          </div>

          {/* add input */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <input value={input} onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') add(); }}
              placeholder="competitor.com" disabled={busy || saved.length >= 8}
              style={{ flex: 1, height: 44, padding: '0 14px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)', background: 'var(--sg-card)', fontFamily: 'var(--sg-font-sans)', fontSize: 14, color: 'var(--sg-text)', outline: 'none' }} />
            <button onClick={add} disabled={busy || !input.trim() || saved.length >= 8}
              style={{ display: 'inline-flex', alignItems: 'center', gap: 7, height: 44, padding: '0 20px', border: 'none', borderRadius: 'var(--sg-radius-pill)', cursor: (busy || !input.trim() || saved.length >= 8) ? 'not-allowed' : 'pointer', opacity: (busy || !input.trim() || saved.length >= 8) ? 0.55 : 1, fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 14, color: '#fff', background: 'var(--sg-grad-brand)' }}>
              <Icon name="plus" size={16} /> Add
            </button>
          </div>
          {msg && <div style={{ marginTop: 10, fontSize: 12.5, color: 'var(--sg-amber)' }}>{msg}</div>}
          {saved.length >= 8 && <div style={{ marginTop: 10, fontSize: 12.5, color: 'var(--sg-text-3)' }}>You can compare up to 8 competitors.</div>}

          {/* discovery — on demand (DataForSEO), not auto-loaded */}
          <div style={{ marginTop: 16, paddingTop: 14, borderTop: '1px solid var(--sg-border)' }}>
            {suggestions == null ? (
              <button onClick={onDiscover} disabled={discovering || saved.length >= 8}
                style={{ display: 'inline-flex', alignItems: 'center', gap: 7, height: 36, padding: '0 14px', borderRadius: 'var(--sg-radius-pill)', border: '1px dashed var(--sg-border-2)', background: 'transparent', cursor: discovering ? 'wait' : 'pointer', fontFamily: 'var(--sg-font-sans)', fontSize: 12.5, fontWeight: 700, color: 'var(--sg-blue-600)' }}>
                <Icon name="sparkles" size={14} /> {discovering ? 'Finding competitors…' : 'Suggest competitors for me'}
              </button>
            ) : discoverable.length > 0 ? (
              <React.Fragment>
                <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--sg-text-3)', marginBottom: 9 }}>Suggested — sites that rank for your keywords</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {discoverable.map((s) => (
                    <button key={s.domain} onClick={() => onAdd(s.domain)} disabled={busy || saved.length >= 8}
                      style={{ display: 'inline-flex', alignItems: 'center', gap: 6, height: 34, padding: '0 13px', borderRadius: 'var(--sg-radius-pill)', border: '1px dashed var(--sg-border-2)', background: 'transparent', cursor: 'pointer', fontFamily: 'var(--sg-font-sans)', fontSize: 12.5, fontWeight: 600, color: 'var(--sg-text-2)' }}>
                      <Icon name="plus" size={13} color="var(--sg-blue-600)" /> {s.domain}
                    </button>
                  ))}
                </div>
              </React.Fragment>
            ) : (
              <div style={{ fontSize: 12.5, color: 'var(--sg-text-3)' }}>No auto-discovered competitors for this domain — add them manually above.</div>
            )}
          </div>
        </div>
      </Card>
    );
  }

  // Real head-to-head from DataForSEO (domain authority, referring domains,
  // organic keywords, est. traffic). Red number = that competitor beats you.
  function LiveComparison({ rows }) {
    const you = rows.find((r) => r.you) || rows[0];
    const fmt = (v) => (v == null ? '—' : v.toLocaleString());
    const METRICS = [
      { key: 'domain_rank', label: 'Domain authority' },
      { key: 'referring_domains', label: 'Referring domains' },
      { key: 'organic_keywords', label: 'Organic keywords' },
      { key: 'organic_etv', label: 'Est. organic traffic / mo', fmt: (v) => (v == null ? '—' : Math.round(v).toLocaleString()) },
    ];
    const cols = `180px repeat(${rows.length}, minmax(0, 1fr))`;
    return (
      <Card style={{ overflow: 'hidden' }}>
        <CardHead title="Head-to-head" sub="Live metrics from DataForSEO — a red number means that competitor is ahead of you on that metric."
          right={<span style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--sg-green)', background: 'var(--sg-green-50)', padding: '3px 10px', borderRadius: 'var(--sg-radius-pill)' }}>● LIVE</span>} />
        <div style={{ overflowX: 'auto' }}>
          <div style={{ display: 'grid', gridTemplateColumns: cols, minWidth: 180 + rows.length * 130 }}>
            <div style={{ padding: '12px 18px', borderBottom: '1px solid var(--sg-border)', fontSize: 10.5, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--sg-text-3)' }}>Metric</div>
            {rows.map((c, i) => (
              <div key={c.domain} style={{ padding: '12px 14px', borderBottom: '1px solid var(--sg-border)', borderLeft: '1px solid var(--sg-border)', background: c.you ? 'var(--sg-blue-50)' : 'transparent', display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ width: 9, height: 9, borderRadius: 3, background: DOT[i % DOT.length], flex: 'none' }} />
                <span style={{ fontSize: 12.5, fontWeight: 700, color: c.you ? 'var(--sg-blue-700)' : 'var(--sg-text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.domain}</span>
                {c.you && <span style={{ fontSize: 9.5, fontWeight: 700, color: 'var(--sg-blue-700)', background: 'var(--sg-card)', padding: '1px 6px', borderRadius: 'var(--sg-radius-pill)' }}>YOU</span>}
              </div>
            ))}
            {METRICS.map((m, mi) => (
              <React.Fragment key={m.key}>
                <div style={{ padding: '14px 18px', borderBottom: mi < METRICS.length - 1 ? '1px solid var(--sg-border)' : 'none', display: 'flex', alignItems: 'center' }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--sg-text)' }}>{m.label}</span>
                </div>
                {rows.map((c) => {
                  const v = c[m.key];
                  const youV = you[m.key];
                  const f = m.fmt || fmt;
                  let color = 'var(--sg-text)';
                  if (!c.you && v != null && youV != null) color = v > youV ? 'var(--sg-red, #DC2626)' : 'var(--sg-green)';
                  return (
                    <div key={c.domain} style={{ padding: '14px', borderLeft: '1px solid var(--sg-border)', borderBottom: mi < METRICS.length - 1 ? '1px solid var(--sg-border)' : 'none', background: c.you ? 'var(--sg-blue-50)' : 'transparent' }}>
                      <span className="sg-tnum" style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 15, color: c.you ? 'var(--sg-blue-700)' : color }}>{f(v)}</span>
                    </div>
                  );
                })}
              </React.Fragment>
            ))}
          </div>
        </div>
      </Card>
    );
  }

  // AI share-of-voice donut — REAL from the GEO scan (your SoV + competitors_share)
  function Donut({ you, geo }) {
    const r = geo && geo.raw;
    if (!r) {
      return (
        <Card><CardHead ai title="AI share of voice" sub="Your slice of AI answers vs competitors" />
          <div style={{ padding: 24, fontSize: 13, color: 'var(--sg-text-2)', lineHeight: 1.55 }}>Run an AI-visibility scan (from the Dashboard or GEO screen) to measure how often AI engines cite you vs your competitors.</div>
        </Card>
      );
    }
    const sov = Math.round(r.share_of_voice ?? 0);
    const compShare = r.competitors_share || {};
    const segs = [{ name: (you || 'you') + ' (you)', v: sov, you: true, color: 'var(--sg-violet-600)' }];
    Object.keys(compShare).forEach((k, i) => segs.push({ name: k, v: Math.round(compShare[k]), color: DOT[(i + 1) % DOT.length] }));
    const sumComp = Object.keys(compShare).reduce((a, k) => a + (compShare[k] || 0), 0);
    const others = Math.max(0, 100 - sov - sumComp);
    if (others > 0.5) segs.push({ name: 'Others', v: Math.round(others), color: 'var(--sg-border-2)' });
    const total = segs.reduce((a, s) => a + s.v, 0) || 1;
    const R = 64, C = 2 * Math.PI * R; let acc = 0;
    return (
      <Card>
        <CardHead ai title="AI share of voice" sub={Object.keys(compShare).length ? 'How often AI engines cite you vs your competitors' : 'Your share of AI answers (add competitors + re-scan to compare)'}
          right={<span style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--sg-green)', background: 'var(--sg-green-50)', padding: '3px 10px', borderRadius: 'var(--sg-radius-pill)' }}>● LIVE</span>} />
        <div style={{ display: 'flex', alignItems: 'center', gap: 22, padding: 20, flexWrap: 'wrap' }}>
          <div style={{ position: 'relative', width: 160, height: 160, flex: 'none' }}>
            <svg width="160" height="160" style={{ transform: 'rotate(-90deg)' }}>
              {segs.map((s) => { const len = (s.v / total) * C; const seg = <circle key={s.name} cx="80" cy="80" r={R} fill="none" stroke={s.color} strokeWidth={s.you ? 22 : 18} strokeDasharray={`${len} ${C - len}`} strokeDashoffset={-acc} />; acc += len; return seg; })}
            </svg>
            <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', lineHeight: 1 }}>
              <span className="sg-tnum" style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 26, color: 'var(--sg-violet-700)' }}>{sov}%</span>
              <span style={{ fontSize: 11, color: 'var(--sg-text-3)', marginTop: 4 }}>you</span>
            </div>
          </div>
          <div style={{ flex: 1, minWidth: 180, display: 'flex', flexDirection: 'column', gap: 9 }}>
            {segs.map((s) => (
              <div key={s.name} style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                <span style={{ width: 11, height: 11, borderRadius: 3, background: s.color }} />
                <span style={{ flex: 1, fontSize: 13, fontWeight: s.you ? 700 : 500, color: s.you ? 'var(--sg-violet-700)' : 'var(--sg-text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.name}</span>
                <span className="sg-tnum" style={{ fontSize: 13, fontWeight: 700, color: 'var(--sg-text)' }}>{s.v}%</span>
              </div>
            ))}
          </div>
        </div>
      </Card>
    );
  }

  // AI prompt gaps — REAL: prompts from the scan where AI didn't surface you
  function Gaps({ geo }) {
    const r = geo && geo.raw;
    if (!r) {
      return (
        <Card><CardHead title="AI prompt gaps" sub="Prompts where AI engines don’t mention you yet" />
          <div style={{ padding: 22, fontSize: 13, color: 'var(--sg-text-2)' }}>Run an AI-visibility scan to find the exact prompts where AI engines recommend others instead of you.</div>
        </Card>
      );
    }
    const ENG = { chatgpt: 'ChatGPT', gemini: 'Gemini', perplexity: 'Perplexity', claude: 'Claude', copilot: 'Copilot' };
    const seen = new Set();
    const gaps = (r.mentions || []).filter((m) => !m.mentioned).filter((m) => { const k = m.query; if (seen.has(k)) return false; seen.add(k); return true; }).slice(0, 8);
    return (
      <Card>
        <CardHead title="AI prompt gaps" sub="Prompts where AI engines don’t mention you yet — your best targets"
          right={<span style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--sg-green)', background: 'var(--sg-green-50)', padding: '3px 10px', borderRadius: 'var(--sg-radius-pill)' }}>● LIVE</span>} />
        {gaps.length === 0
          ? <div style={{ padding: 22, fontSize: 13, color: 'var(--sg-text-2)' }}>AI engines surfaced you in every prompt we checked — great coverage. 🎉</div>
          : gaps.map((g, i) => {
            const comp = (g.competitors_mentioned || []).filter(Boolean);
            return (
              <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 140px', alignItems: 'center', gap: 14, padding: '13px 20px', borderBottom: i < gaps.length - 1 ? '1px solid var(--sg-border)' : 'none' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                  <span style={{ width: 26, height: 26, borderRadius: 7, flex: 'none', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: 'var(--sg-violet-100)', color: 'var(--sg-violet-700)' }}><Icon name="sparkles" size={13} /></span>
                  <span style={{ fontSize: 13.5, color: 'var(--sg-text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={g.query}>“{g.query}”</span>
                </div>
                <span style={{ fontSize: 12, color: 'var(--sg-text-2)', textAlign: 'right' }}>{comp.length ? <span>they cite <strong style={{ color: 'var(--sg-text)' }}>{comp[0]}</strong></span> : (ENG[g.platform] || g.platform)}</span>
              </div>
            );
          })}
      </Card>
    );
  }

  function LiveCompetitors({ comps }) {
    const max = Math.max(1, ...comps.map((c) => c.intersections || 0));
    return (
      <Card>
        <CardHead title="Top organic competitors" sub="Sites ranking for the same Google keywords as you — from DataForSEO"
          right={<span style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--sg-green)', background: 'var(--sg-green-50)', padding: '3px 10px', borderRadius: 'var(--sg-radius-pill)' }}>● LIVE</span>} />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 150px 130px 120px', gap: 14, padding: '10px 20px', borderBottom: '1px solid var(--sg-border)', fontSize: 10.5, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--sg-text-3)' }}>
          <span>Competitor</span><span>Shared keywords</span><span>Organic kw</span><span>Est. traffic</span>
        </div>
        {comps.map((c, i) => (
          <div key={i} style={{ display: 'grid', gridTemplateColumns: '1fr 150px 130px 120px', gap: 14, padding: '12px 20px', alignItems: 'center', borderBottom: i < comps.length - 1 ? '1px solid var(--sg-border)' : 'none' }}>
            <span style={{ fontSize: 13.5, fontWeight: 600, color: 'var(--sg-text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.domain}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{ flex: 1, height: 6, borderRadius: 999, background: 'var(--sg-sunken)', overflow: 'hidden', minWidth: 50 }}>
                <div style={{ width: ((c.intersections || 0) / max * 100) + '%', height: '100%', borderRadius: 999, background: 'var(--sg-grad-brand)' }} />
              </div>
              <span className="sg-tnum" style={{ fontSize: 13, fontWeight: 700, width: 28, textAlign: 'right' }}>{c.intersections}</span>
            </div>
            <span className="sg-tnum" style={{ fontSize: 13, color: 'var(--sg-text-2)' }}>{c.organic_keywords != null ? c.organic_keywords.toLocaleString() : '—'}</span>
            <span className="sg-tnum" style={{ fontSize: 13, color: 'var(--sg-text-2)' }}>{c.organic_etv != null ? '$' + Math.round(c.organic_etv).toLocaleString() : '—'}</span>
          </div>
        ))}
      </Card>
    );
  }

  /* Head-to-head on the keywords the CLIENT CHOSE: your Google position vs each
     competitor's, keyword by keyword. On-demand (paid DataForSEO, cached). */
  function KeywordGap({ you, saved }) {
    const [data, setData] = React.useState(null);
    const [busy, setBusy] = React.useState(false);
    const [onlyBehind, setOnlyBehind] = React.useState(false);
    React.useEffect(() => { setData(null); }, [you, saved.length]);
    const run = () => {
      if (busy) return;
      setBusy(true);
      window.SGLive.fetchKeywordGap().then((d) => { setBusy(false); setData(d || { error: true }); });
    };
    const comps = (data && data.competitors) || [];
    const all = (data && data.keywords) || [];
    const list = onlyBehind ? all.filter((k) => k.behind) : all;
    const behindCount = all.filter((k) => k.behind).length;
    const cell = (p, isYou, best) => {
      const ahead = p != null && best != null && p <= best;
      return (
        <span className="sg-tnum" style={{ fontFamily: 'var(--sg-font-display)', fontWeight: 700, fontSize: 14,
          color: p == null ? 'var(--sg-text-3)' : isYou ? (ahead ? 'var(--sg-green)' : 'var(--sg-red, #DC2626)') : 'var(--sg-text)' }}>
          {p == null ? '—' : p}
        </span>
      );
    };
    const grid = `1.6fr repeat(${Math.max(1, comps.length) + 1}, 92px)`;
    return (
      <Card style={{ overflow: 'hidden' }}>
        <CardHead title="Keyword head-to-head" icon="list-ordered"
          sub="Your Google position vs your competitors', on the keywords you chose to track. “—” means not in the top 100."
          right={<button onClick={run} disabled={busy} style={{ display: 'inline-flex', alignItems: 'center', gap: 7, height: 34, padding: '0 14px', border: 'none', borderRadius: 'var(--sg-radius-pill)', cursor: busy ? 'wait' : 'pointer', opacity: busy ? 0.6 : 1, fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 12.5, color: '#fff', background: 'var(--sg-grad-brand)' }}>
            <Icon name="target" size={14} /> {busy ? 'Comparing…' : (data ? 'Refresh' : 'Compare keywords')}
          </button>} />
        <div style={{ padding: 18 }}>
          {!data && !busy && <div style={{ fontSize: 13, color: 'var(--sg-text-2)', lineHeight: 1.55 }}>See exactly where you stand against {saved.length === 1 ? 'your competitor' : `your ${saved.length} competitors`} on each keyword you track — and which ones they’re beating you on.</div>}
          {busy && <div style={{ fontSize: 13, color: 'var(--sg-text-2)' }}>Looking up your competitors’ rankings…</div>}
          {data && data.error && <div style={{ fontSize: 13, color: 'var(--sg-text-2)' }}>Couldn’t run the comparison right now — try again shortly.</div>}
          {data && !data.error && all.length === 0 && (
            <div style={{ fontSize: 13, color: 'var(--sg-text-2)', lineHeight: 1.55 }}>No keywords to compare yet — choose the keywords you want to track in <strong>Site Audit</strong> or the <strong>Keywords</strong> tab first.</div>
          )}
          {data && !data.error && all.length > 0 && (
            <React.Fragment>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 12.5, color: 'var(--sg-text-2)' }}>
                  {behindCount > 0
                    ? <React.Fragment>A competitor outranks you on <strong style={{ color: 'var(--sg-red, #DC2626)' }}>{behindCount}</strong> of your {all.length} keywords.</React.Fragment>
                    : <React.Fragment>You’re ahead of your competitors on all {all.length} tracked keywords.</React.Fragment>}
                </span>
                {behindCount > 0 && (
                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12.5, color: 'var(--sg-text-2)', cursor: 'pointer' }}>
                    <input type="checkbox" checked={onlyBehind} onChange={(e) => setOnlyBehind(e.target.checked)} style={{ accentColor: 'var(--sg-blue-600)', cursor: 'pointer' }} />
                    Only where I’m behind
                  </label>
                )}
              </div>
              <div style={{ border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-md)', overflow: 'auto' }}>
                <div style={{ display: 'grid', gridTemplateColumns: grid, gap: 0, padding: '10px 14px', borderBottom: '1px solid var(--sg-border)', fontSize: 10.5, fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--sg-text-3)', minWidth: 520 }}>
                  <span>Keyword</span>
                  <span style={{ color: 'var(--sg-blue-700)' }}>You</span>
                  {comps.map((d) => <span key={d} style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={d}>{d.replace(/^www\./, '').split('.')[0]}</span>)}
                </div>
                {list.slice(0, 50).map((k, i) => {
                  const best = Object.values(k.competitors || {}).filter((p) => p != null).sort((a, b) => a - b)[0];
                  return (
                    <div key={k.keyword} style={{ display: 'grid', gridTemplateColumns: grid, alignItems: 'center', gap: 0, padding: '11px 14px', borderTop: i ? '1px solid var(--sg-border)' : 'none', background: k.behind ? 'var(--sg-red-50, #FDECEC)' : 'transparent', minWidth: 520 }}>
                      <span style={{ fontSize: 13, color: 'var(--sg-text)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingRight: 10 }}>{k.keyword}</span>
                      <span>{cell(k.you, true, best == null ? null : best)}</span>
                      {comps.map((d) => <span key={d}>{cell(k.competitors ? k.competitors[d] : null, false, null)}</span>)}
                    </div>
                  );
                })}
              </div>
            </React.Fragment>
          )}
        </div>
      </Card>
    );
  }

  function Competitors() {
    const { site, prettySite } = window.SGLive.useLive();
    const ent = window.SGLive.useEntitlement();
    const locked = ent.paidData === false;
    const you = site ? prettySite(site) : '';

    const [saved, setSaved] = React.useState([]);
    const [discovered, setDiscovered] = React.useState(null);
    const [rows, setRows] = React.useState(null);
    const [busy, setBusy] = React.useState(false);
    const [comparing, setComparing] = React.useState(false);
    const [msg, setMsg] = React.useState(null);

    const recompare = React.useCallback(() => {
      setComparing(true);
      window.SGLive.compareCompetitors(you || undefined).then((r) => {
        setComparing(false);
        if (r.ok) setRows(r.rows);
      });
    }, [you]);

    // initial load: this domain's saved competitors + auto-discovered + comparison.
    const [discovering, setDiscovering] = React.useState(false);
    const [geo, setGeo] = React.useState(null); // latest GEO audit for the selected domain (real SoV/gaps)
    // Only the saved list (our DB, free) auto-loads. The DataForSEO head-to-head
    // and competitor discovery wait for an explicit click → no auto-charge.
    React.useEffect(() => {
      if (locked) return undefined;
      setRows(null); setDiscovered(null); setGeo(null);
      window.SGLive.fetchSavedCompetitors(you || undefined).then((r) => setSaved(r.domains || []));
      if (you) window.SGLive.fetchLatestAudit(you, 'geo').then(setGeo); // free (reads stored scan)
      return undefined;
    }, [locked, you]);

    const discover = () => {
      setDiscovering(true);
      window.SGLive.fetchCompetitors(you || undefined).then((d) => { setDiscovered(d || []); setDiscovering(false); });
    };

    const onAdd = (domain) => {
      if (!you) { setMsg('Pick a domain in the top bar first.'); return; }
      setBusy(true); setMsg(null);
      window.SGLive.addCompetitor(you, domain).then((r) => {
        setBusy(false);
        if (r.ok) { setSaved(r.domains); setRows(null); } // mark comparison stale (don't auto-charge)
        else setMsg(r.error || 'Could not add competitor');
      });
    };
    const onRemove = (domain) => {
      setBusy(true);
      window.SGLive.removeCompetitor(you, domain).then((r) => {
        setBusy(false);
        if (r.ok) { setSaved(r.domains); setRows(null); }
      });
    };

    return (
      <div style={{ maxWidth: 1180, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 20 }}>
        <PageHead eyebrow="Research" title="Competitors" icon="target" sub="Compare your site against the competitors you choose — in search AND in AI answers." />
        {locked ? (
          <window.SGLive.PaidLock title="Competitor analysis unlocks on a paid plan" blurb="Add your competitors’ websites and see a real head-to-head — domain authority, referring domains, organic keywords and estimated traffic — using premium search data. Upgrade to unlock." />
        ) : (
          <React.Fragment>
            <CompetitorManager you={you} saved={saved} suggestions={discovered} discovering={discovering} busy={busy} msg={msg} onAdd={onAdd} onRemove={onRemove} onDiscover={discover} />

            {saved.length > 0
              ? (rows && rows.length > 1
                ? (
                  <React.Fragment>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <button onClick={recompare} disabled={comparing} style={{ display: 'inline-flex', alignItems: 'center', gap: 6, height: 34, padding: '0 13px', border: '1px solid var(--sg-border)', borderRadius: 'var(--sg-radius-pill)', background: 'var(--sg-card)', cursor: 'pointer', fontSize: 12.5, fontWeight: 600, color: 'var(--sg-text-2)' }}><Icon name="refresh-cw" size={13} /> {comparing ? 'Refreshing…' : 'Refresh'}</button>
                    </div>
                    <LiveComparison rows={rows} />
                    <KeywordGap you={you} saved={saved} />
                  </React.Fragment>
                )
                : <Card style={{ padding: '34px 24px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
                    <span style={{ width: 52, height: 52, borderRadius: 14, background: 'var(--sg-blue-50)', color: 'var(--sg-blue-600)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><Icon name="target" size={24} /></span>
                    <div style={{ fontSize: 14, color: 'var(--sg-text-2)', maxWidth: 420, lineHeight: 1.5 }}>{comparing ? 'Pulling live metrics for your competitors…' : `Run a live head-to-head for ${you || 'this domain'} vs your ${saved.length} competitor${saved.length === 1 ? '' : 's'}. Cached for a week, so re-running is free.`}</div>
                    <button onClick={recompare} disabled={comparing} style={{ display: 'inline-flex', alignItems: 'center', gap: 8, height: 44, padding: '0 22px', border: 'none', borderRadius: 'var(--sg-radius-pill)', cursor: comparing ? 'wait' : 'pointer', fontFamily: 'var(--sg-font-sans)', fontWeight: 700, fontSize: 14, color: '#fff', background: 'var(--sg-grad-brand)', boxShadow: '0 3px 10px rgba(37,99,235,0.26)' }}>
                      <Icon name="activity" size={16} /> {comparing ? 'Running…' : 'Run head-to-head'}
                    </button>
                  </Card>)
              : <Card style={{ padding: 18, display: 'flex', alignItems: 'center', gap: 12, background: 'var(--sg-sunken)' }}>
                  <Icon name="target" size={18} color="var(--sg-text-3)" />
                  <div style={{ flex: 1, fontSize: 13, color: 'var(--sg-text-2)' }}>Add your competitors’ websites above (or let us suggest some) to build a live head-to-head comparison.</div>
                </Card>}

            {discovered && discovered.length > 0 && <LiveCompetitors comps={discovered} />}

            {/* GEO / AI competitive visibility — real from the latest scan */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.4fr', gap: 20, alignItems: 'start' }}>
              <Donut you={you} geo={geo} />
              <Gaps geo={geo} />
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }

  window.SGCompetitors = Competitors;
})();
